import { MapboxMapStyleId } from '../../services/geometry.service';
import { OfflineMap } from '../../types/offlineMaps.types';

import { MapState } from './map.reducer';

export const getMapBaseStyleId = (state: MapState): MapboxMapStyleId | OfflineMap['uuid'] => state.baseStyleId;
export const getMapShowAppBounds = (state: MapState): boolean => state.showAppBounds;
export const getMapShowScaleBar = (state: MapState): boolean => state.showScaleBar;
